export default __webpack_public_path__ + "static/media/swissmom-logo-white.6ba3ef38.webp";